import React from 'react';
import { NavLink } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const Sidebar = ({ isOpen, onClose, currentPath }) => {
  const { user } = useAuth();

  const navigation = [
    { name: '仪表盘', path: '/dashboard', icon: 'fa-dashboard' },
    { name: '安全巡检管理', path: '/inspections', icon: 'fa-check-square-o' },
    { name: '安全培训管理', path: '/trainings', icon: 'fa-graduation-cap' },
    { name: '安全证件管理', path: '/certificates', icon: 'fa-id-card-o' },
  ];

  // 只有管理员可以访问系统管理
  if (user?.role === 'admin') {
    navigation.push({ name: '系统管理', path: '/system', icon: 'fa-cog' });
  }

  return (
    <>
      {/* 移动端侧边栏 */}
      <div
        className={`fixed inset-y-0 left-0 z-50 w-64 bg-primary transform transition-transform duration-300 ease-in-out lg:hidden ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        }`}
      >
        <div className="h-full flex flex-col">
          <div className="flex items-center justify-between h-16 px-4 border-b border-blue-700">
            <div className="flex items-center">
              <div className="h-8 w-8 bg-blue-500 rounded-md flex items-center justify-center">
                <i className="fa fa-shield text-white"></i>
              </div>
              <span className="ml-2 text-lg font-semibold text-white">管理平台</span>
            </div>
            <button
              onClick={onClose}
              className="p-2 rounded-md text-gray-200 hover:text-white hover:bg-blue-700 focus:outline-none"
            >
              <i className="fa fa-times"></i>
            </button>
          </div>
          <nav className="flex-1 px-2 py-4 space-y-1">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                    isActive || currentPath.startsWith(item.path)
                      ? 'bg-blue-700 text-white'
                      : 'text-gray-200 hover:bg-blue-700 hover:text-white'
                  }`
                }
                onClick={onClose}
              >
                <i className={`fa ${item.icon} w-5 h-5 mr-3`}></i>
                {item.name}
              </NavLink>
            ))}
          </nav>
          <div className="p-4 border-t border-blue-700">
            <div className="text-xs text-gray-300 text-center">
              <p>昊天安全管理平台</p>
              <p className="mt-1">v2.0.0</p>
            </div>
          </div>
        </div>
      </div>

      {/* 桌面端侧边栏 */}
      <aside className="bg-primary w-64 flex-shrink-0 hidden lg:flex lg:flex-col">
        <div className="h-full flex flex-col">
          <div className="flex items-center h-16 px-4 border-b border-blue-700">
            <div className="h-8 w-8 bg-gradient-to-br from-yellow-400 to-orange-500 rounded-md flex items-center justify-center shadow-md">
              <i className="fa fa-sun-o text-white"></i>
            </div>
            <span className="ml-2 text-lg font-semibold text-white">昊天安全</span>
          </div>
          <nav className="flex-1 px-2 py-4 space-y-1">
            {navigation.map((item) => (
              <NavLink
                key={item.name}
                to={item.path}
                className={({ isActive }) =>
                  `flex items-center px-3 py-2 text-sm font-medium rounded-md transition-colors ${
                    isActive || currentPath.startsWith(item.path)
                      ? 'bg-blue-700 text-white'
                      : 'text-gray-200 hover:bg-blue-700 hover:text-white'
                  }`
                }
              >
                <i className={`fa ${item.icon} w-5 h-5 mr-3`}></i>
                {item.name}
            </NavLink>
          ))}
        </nav>
        <div className="p-4 border-t border-blue-700">
          <div className="text-xs text-gray-300 text-center">
            <p>昊天安全管理平台</p>
            <p className="mt-1">v2.0.0</p>
          </div>
        </div>
      </div>
    </aside>
    </>
  );
};

export default Sidebar;